import { MediaSearchGallery } from "../components/search/MediaSearchGallery";
import type { ContentType } from "../api/types";

/** Module-level so the array identity stays stable across renders. */
const PHOTOS: ContentType[] = ["PHOTO"];

/**
 * Photographs gallery. A searchable, tag-filterable, sortable, paginated
 * contact sheet — each frame links to its document page, where the photo is
 * shown full size and can be commented on.
 *
 * Runs at `scope="MAIN"`, so collections that have their own section (the scuba
 * library) stay out of this sheet. The gallery says how many it is holding back
 * and links straight to that section; nothing is hidden from search.
 */
export function PhotosPage() {
  return (
    <div className="page">
      <div className="container">
        <header className="page__head">
          <p className="eyebrow">Collection 01 · Photos</p>
          <h1 className="page__title">Photos</h1>
          <p className="page__intro">
            Dogs, friends, the road, and the odd mural. Search, filter by tag or
            year, and sort — each shot is catalogued and clickable.
          </p>
        </header>

        <MediaSearchGallery
          types={PHOTOS}
          scope="MAIN"
          noun="photo"
          placeholder="Search photos…"
          emptyLabel="No photos match your search."
          categories={[
            { label: "All", tag: null },
            { label: "Travel", tag: "travel" },
            { label: "Friends", tag: "friends" },
            { label: "Family", tag: "family" },
            { label: "Dogs", tag: "dogs" },
            { label: "Wildlife", tag: "wildlife" },
            { label: "DC", tag: "dc" },
            { label: "Europe", tag: "europe" },
            { label: "Colombia", tag: "colombia" },
            { label: "Philippines", tag: "philippines" },
            { label: "Indonesia", tag: "indonesia" },
            { label: "Throwback", tag: "throwback" },
          ]}
        />
      </div>
    </div>
  );
}
